import React, { useState, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Input from 'src/components/ui/Input/Input';
import ModalListItem from 'src/components/layouts/ModalListItem/ModalListItem';
import Modal from '../../layouts/Modal/Modal';
import './SelectStatisticDataModal.scss';

type ListItem = {
  statisticType: string;
};

export type SelectStatisticDataModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onItemSelect?: (selectedItem: string) => void;
  listItems: ListItem[];
};

const SelectStatisticDataModal: React.FC<SelectStatisticDataModalProps> = ({
  isOpen,
  onClose,
  listItems,
  onItemSelect,
}) => {
  const { t } = useTranslation();
  const sortItemsByStatisticType = (items: ListItem[]) => {
    return items.sort((a, b) => a.statisticType.localeCompare(b.statisticType));
  };

  const [selectedStatistic, setSelectedStatistic] = useState('');
  const [filteredItems, setFilteredItems] = useState<ListItem[]>(sortItemsByStatisticType(listItems));

  const handleStatisticChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSelectedStatistic(value);
    const filtered = listItems.filter(item => item.statisticType.toLowerCase().includes(value.toLowerCase()));
    setFilteredItems(filtered);
  };

  const handleItemClick = (statisticType: string) => {
    if (onItemSelect) {
      onItemSelect(statisticType);
    }
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} hasBackdrop={false}>
      <div className="selectStatisticDataModal w-[320px] h-[320px] mx-auto surface-elevated rounded-lg shadow-lg">
        <div className="flex flex-col md:flex-row justify-between h-[310px]">
          <div className="">
            <div className="pl-5 pr-5 pt-4">
              <h2 className="text-base font-bold mb-2">{t('general.select_data')}</h2>
              <Input
                value={selectedStatistic}
                icon="search"
                onChange={handleStatisticChange}
                placeholder={t('general.search_placeholder')}
                className="pl-9 pb-2 pt-2 h-9 w-72 color-grey"
                clearable={!!selectedStatistic}
              />
            </div>
            <ul className="list-none pt-4 statisticSection h-[220px] w-[318px] overflow-x-hidden">
              {filteredItems.map(item => (
                <ModalListItem
                  key={item.statisticType}
                  item={item}
                  onClick={() => handleItemClick(item.statisticType)}
                  onKeyDown={() => handleItemClick(item.statisticType)}
                  type="statisticType"
                />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SelectStatisticDataModal;
